/**
 * Constants
 */
const SET_LATEST_NEWS = 'site@SET_LATEST_NEWS';
const SET_PRODUCTIONS = 'site@SET_PRODUCTIONS';
const SET_NEWS = 'site@SET_NEWS';
const ADD_NEWS = 'site@ADD_NEWS';
const SET_PAGE = 'site@SET_PAGE';

/**
 * Actions creator
 */
const setLatestNews = items => ({
    type: SET_LATEST_NEWS,
    payload: items,
});

const setProductions = items => ({
    type: SET_PRODUCTIONS,
    payload: items,
});

const setNews = items => ({
    type: SET_NEWS,
    payload: items,
});

const addNews = items => ({
    type: ADD_NEWS,
    payload: items,
});

const setPage = page => ({
    type: SET_PAGE,
    payload: page,
});

/**
 * Exports
 */
export {
    SET_LATEST_NEWS,
    SET_PRODUCTIONS,
    SET_NEWS,
    ADD_NEWS,
    SET_PAGE,

    setLatestNews,
    setProductions,
    setNews,
    addNews,
    setPage,
};



// WEBPACK FOOTER //
// ./js/actions/SiteActions.js